(async () => {
  if (!window.location.pathname.includes('/products/')) return;
  const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
  if (!productHandle) return;

  const query = `{
    product(handle: "${productHandle}") {
      metafield(namespace: "custom", key: "linked_colors") {
        references(first: 20) {
          nodes {
            ... on Product {
              title
              handle
              featuredImage { url(transform: {maxWidth: 200}) }
            }
          }
        }
      }
    }
  }`;

  try {
    const res = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query })
    });

    const data = await res.json();
    const nodes = data?.data?.product?.metafield?.references?.nodes;
    if (!nodes?.length) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'linked-colors-wrapper';
    wrapper.innerHTML = `
      <p class="linked-colors-label">Renk Seçenekleri</p>
      <div class="linked-colors-grid">
        ${nodes.map(p => `
          <a href="/products/${p.handle}" class="linked-color-item ${p.handle === productHandle ? 'active' : ''}">
            ${p.featuredImage ? `<img src="${p.featuredImage.url}" alt="${p.title}" width="80" height="80">` : ''}
            <span>${p.title}</span>
          </a>
        `).join('')}
      </div>
    `;

    const target = document.querySelector('.product-details');
    if (target) target.prepend(wrapper);
  } catch(e) {
    console.error('Linked colors error:', e);
  }
})();